import React from 'react'
import type { ImageProps } from 'cloudinary-react'
import CloudinaryImage from '@paintscout/ui/components/CloudinaryImage'
import { useClientOptions } from '../../providers/ClientOptionsProvider'

export interface ClientLogoProps extends Omit<ImageProps, 'publicId' | 'src'> {}

/**
 * Loads the client logo with a Cloudinary image using $options
 */
export default function ClientLogo(props: ClientLogoProps) {
  const { options } = useClientOptions()

  if (options.options.logo?.cloudinaryId) {
    return <CloudinaryImage publicId={options.options.logo.cloudinaryId} {...props} />
  }
  return null
}
